import { reactive } from 'vue';
import { ajax200Res } from '@/js/utils';
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { computed } from "vue";
import { basePost, Member } from "@/js/services/baseService";
import { getBarcodeUrl } from "@/js/functions";
import { $ } from "dom7";
export default {
  props: {
    codeValue: {
      type: String,
      default: ''
    },
    width: {
      type: [Number, String],
      default: 4
    },
    height: {
      type: [Number, String],
      default: 40
    }
  },
  setup: function setup(props, context) {
    var cData = reactive({
      src: ""
    });
    var upperCaseCode = computed(function () {
      return props.codeValue.toUpperCase();
    });
    var imgSrc = computed(function () {
      if (!upperCaseCode.value) return;

      try {
        var src = getBarcodeUrl(upperCaseCode.value, props.width, props.height);
        cData.src = src;
        return cData.src;
      } catch (error) {
        barCodeCheck();
      }
    });

    function barCodeCheck() {
      return _barCodeCheck.apply(this, arguments);
    }

    function _barCodeCheck() {
      _barCodeCheck = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var res, _ajax200Res, onSuccess, onFail;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(cData.src === '')) {
                  _context.next = 7;
                  break;
                }

                _context.next = 3;
                return Member.createBarcode({
                  'barCode': upperCaseCode.value
                });

              case 3:
                res = _context.sent;
                _ajax200Res = ajax200Res(res), onSuccess = _ajax200Res.onSuccess, onFail = _ajax200Res.onFail;
                onSuccess(function (_ref) {
                  var res = _ref.res,
                      data = _ref.data,
                      msg = _ref.msg,
                      defaultAlert = _ref.defaultAlert;
                  console.log('data', data);

                  if (data) {
                    console.log('imgSrc2', data.path);
                    cData.src = data.path;
                    console.log('imgSrc3', cData.src);
                  }
                });
                onFail(function (_ref2) {
                  var res = _ref2.res,
                      data = _ref2.data,
                      msg = _ref2.msg,
                      defaultAlert = _ref2.defaultAlert;

                  if (msg) {
                    defaultAlert();
                  }
                });

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return _barCodeCheck.apply(this, arguments);
    }

    return {
      imgSrc: imgSrc,
      upperCaseCode: upperCaseCode
    };
  }
};